import { cssUtil } from "../utils/cssUtil.js";
import { getBaseStyles } from "./commonStyles.js";

export function renderLineWidget(context, widget, parent) {

    // <div class="widget line_widget">
    const el = context.document.createElement("div");
    el.classList.add("widget", "line_widget");
    const breakpoint = context.currentBreakpoint;

    // base widget styles (layout, transform, position, etc.)
    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };
    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);

    // <div class="line">
    const lineEl = context.document.createElement("div");
    lineEl.classList.add("line");

    const lineStyles = getLineStyles(widget);
    lineEl.setAttribute("style", cssUtil.toStyleString(lineStyles));

    el.appendChild(lineEl);
    parent.appendChild(el);

    return el;
}

function getLineStyles(widget) {
    const styles = {};

    const props = widget?.properties?.desktop;
    if (!props || !props.stroke) return styles;

    const stroke = props.stroke;

    // COLOR
    if (stroke.color) {
        if (stroke.color.type === "solid") {
            styles["border-top-color"] = cssUtil.getCssColor(stroke.color);
        } else if (stroke.color.type === "gradient") {
            styles["border-top-color"] = cssUtil.getCssGradient(stroke.color);
        }
    }

    // WIDTH
    if (stroke.width != null) {
        styles["border-top-width"] = `${stroke.width}px`;
    }

    // STYLE (solid / dashed / dotted)
    if (props.type) {
        styles["border-top-style"] = props.type.toLowerCase();
    }

    return styles;
}